import { message } from './Endpoints'
import axios from 'axios'

export default {
    async postMessage(data, config) {
        const response = await axios.post(message.onPostMessage(), data, config);
        return response.data;
    }
}